/* eslint-disable @typescript-eslint/no-explicit-any */
import { v4 } from 'uuid';

import { blueprintKitchenData7 } from '../../defaults';
import { deepCopy } from '../../../helpers';
import { updateIslands } from './update-islands';
import { BlueprintData6, BlueprintData7, BlueprintKitchenData7 } from '../../types';
import { KitchenMaterial } from '../../../blueprint-classes';

export const updateKitchens = (blueprint: BlueprintData6): BlueprintData7['kitchens'] => {
	const description = blueprint.layout.replace(/"/gu, '').replace(/\//gu, '');
	const bpStates = typeof blueprint.state === 'string' ? JSON.parse(blueprint.state) : blueprint.state;

	const kitchens = bpStates.map((state, iState) => {
		const material = new KitchenMaterial({ dataIn: {
			countertop: {
				key: state.material.countertop,
				thickness: state.material.countertopThickness
			},
			surround: {
				key: state.material.surround
			}
		}});
		const materialData = material.serialize();
		materialData.surround.override = false;

		return {
			...deepCopy(blueprintKitchenData7),
			id: v4(),
			baseVersion: iState === 0 ? null : iState,
			version: iState + 1,
			createdBy: 'SYSTEM',
			createDate: blueprint.date,
			fuelchoice: state.fuelchoice,
			description,
			kitchenLayout: description,
			material: materialData,
			design: {
				islands: updateIslands(state, materialData.surround),
				countertops: state.islands.map((island) => {
					return {
						id: v4(),
						islandIds: [island.key]
					};
				})
			}
		} as BlueprintKitchenData7;
	});

	return kitchens;
};
